import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
import FJConfig from '../../config/FJConfig.js';
import FJUtil from '../../util/FJUtil.js';

export const FJSliceCommon = createSlice({
    name: 'common',
    initialState: {
        isApplyButton: false,
        isDone: false, // AI工具已经加工完成并返回了数据
        appType: FJConfig.appType,
        creationList: [
            // {
            //     id: 878637,
            //     imgUrl: 'https://da1mnv1i99sez.cloudfront.net/ai/export/img2img/638beeacd7829d7f7410a6fb061df4c4_0.png',
            //     type: 'CREATIONS',
            //     width: 1088,
            //     height: 960,
            //     originalUrl:
            //         'https://da1mnv1i99sez.cloudfront.net/ai/input/img2img/d2c74f6a37e7575470ad33da9fc70a4cb26ace99970417013852c577ff106af5.png',
            //     createTime: '2025-01-21 06:03:15',
            //     hasWaterMark: 1,
            //     style: 'purple-american-comic',
            // },
        ],
        historyList: [],
        selectedDownloadList: [],
        selectList: [],
        freeNumCreation: 0,
        creditNumber: 0,
        headerTabIndex: 0,
        isDraggingFile: false,
        taskStatus: FJConstant.DEFAULT,
        progress: 0,
        currentQueue: 0,
        queueNumber: 0,
        isProjectLoading: false,
        batchDownloadLoading: false,
        historyListLoadStatus: FJConstant.SUCCESS,
        isShowMobileHistory: false,
        isMobileMultiSelect: false,
        isLogin: FJUtil.isLogin(),
        mobileGenerateSuccessPreviewIndex: 0,
    },
    reducers: {
        setSliceTaskStatusAction: (state, action) => {
            state.taskStatus = action.payload;
        },
        setSliceProgressAction: (state, action) => {
            state.progress = action.payload;
        },
        setSliceCurrentQueueAction: (state, action) => {
            state.currentQueue = action.payload;
        },
        setSliceQueueNumberAction: (state, action) => {
            state.queueNumber = action.payload;
        },

        setSliceIsDraggingFileAction: (state, action) => {
            state.isDraggingFile = action.payload;
        },
        setSliceHeaderTabIndexAction: (state, action) => {
            state.headerTabIndex = action.payload;
        },

        setSliceCreationListAction: (state, action) => {
            if (!action.payload) return;
            const isLoading = action.payload.filter(i => i.isLoading).length !== 0;
            const isFailed = action.payload.filter(i => i.isReload).length !== 0;
            state.creationList = action.payload;
            state.isDone = action.payload.length > 0 && !isLoading && !isFailed;
            if (state.isDone) state.selectedDownloadList = action.payload;
        },
        setSliceHistoryListAction: (state, action) => {
            state.historyList = action.payload;
        },
        setSliceSelectListAction: (state, action) => {
            state.selectList = action.payload;
        },

        setSliceFreeNumCreationAction: (state, action) => {
            state.freeNumCreation = action.payload;
        },
        setSliceCreditNumberAction: (state, action) => {
            state.creditNumber = action.payload;
        },
        setSliceIsProjectLoadingAction: (state, action) => {
            state.isProjectLoading = action.payload;
        },
        setSliceBatchDownloadLoadingAction: (state, action) => {
            state.batchDownloadLoading = action.payload;
        },
        setSliceHistoryListLoadStatusAction: (state, action) => {
            state.historyListLoadStatus = action.payload;
        },
        setSliceIsShowMobileHistory: (state, action) => {
            state.isShowMobileHistory = action.payload;
        },
        setSliceIsMobileMultiSelect: (state, action) => {
            state.isMobileMultiSelect = action.payload;
        },
        setSliceIsLogin: (state, action) => {
            state.isLogin = action.payload;
        },
        setAppTypeAction: (state, action) => {
            state.appType = action.payload;
        },
        setIsApplyButtonAction: (state, action) => {
            state.isApplyButton = action.payload;
        },
        setSelectedDownloadList: (state, action) => {
            state.selectedDownloadList = action.payload;
        },
        setSliceMobileGenerateSuccessPreviewIndex: (state, action) => {
            state.mobileGenerateSuccessPreviewIndex = action.payload;
        },
    },
});

export const {
    setAppTypeAction,
    setIsApplyButtonAction,
    setSliceCreationListAction,
    setSliceHistoryListAction,
    setSliceSelectListAction,
    setSliceFreeNumCreationAction,
    setSliceCreditNumberAction,
    setSliceHeaderTabIndexAction,
    setSliceIsDraggingFileAction,
    setSliceTaskStatusAction,
    setSliceProgressAction,
    setSliceCurrentQueueAction,
    setSliceQueueNumberAction,
    setSliceIsProjectLoadingAction,
    setSliceBatchDownloadLoadingAction,
    setSliceHistoryListLoadStatusAction,
    setSliceIsShowMobileHistory,
    setSliceIsMobileMultiSelect,
    setSliceIsLogin,
    setSelectedDownloadList,
    setSliceMobileGenerateSuccessPreviewIndex,
} = FJSliceCommon.actions;
export default FJSliceCommon.reducer;
